// src/components/Admin/BookingsCalendar.jsx
import React, { useMemo } from 'react';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import { format, parse, startOfWeek, getDay } from 'date-fns';
import enUS from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';
import { useTranslation } from 'react-i18next';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const locales = { en: enUS, es };
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const BookingsCalendar = ({ bookings, onSelectBooking }) => {
  const { i18n } = useTranslation();
  const currentLocale = i18n.language === 'es' ? 'es' : 'en';

  const events = useMemo(() => {
    return bookings.map(booking => ({
      id: booking._id,
      title: `${booking.user?.fullname || 'Guest'} - ${booking.room?.name || 'Room'}`,
      start: new Date(booking.checkInDate),
      end: new Date(booking.checkOutDate),
      status: booking.status,
      allDay: true, // display as full-day event
    }));
  }, [bookings]);

  const eventStyleGetter = (event) => {
    let backgroundColor = '#3b82f6'; // blue default
    if (event.status === 'confirmed') backgroundColor = '#10b981'; // green
    if (event.status === 'checked-in') backgroundColor = '#f59e0b'; // orange
    if (event.status === 'checked-out') backgroundColor = '#6b7280'; // gray
    if (event.status === 'cancelled') backgroundColor = '#ef4444'; // red
    return {
      style: {
        backgroundColor,
        borderRadius: '4px',
        color: 'white',
        border: 'none',
        padding: '2px 4px',
        fontSize: '0.75rem',
      },
    };
  };

  const handleSelectEvent = (event) => {
    if (onSelectBooking) {
      const fullBooking = bookings.find(b => b._id === event.id);
      onSelectBooking(fullBooking);
    }
  };

  return (
    <div className="h-[600px]">
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: '100%' }}
        eventPropGetter={eventStyleGetter}
        onSelectEvent={handleSelectEvent}
        messages={
          currentLocale === 'es'
            ? {
                next: 'Siguiente',
                previous: 'Anterior',
                today: 'Hoy',
                month: 'Mes',
                week: 'Semana',
                day: 'Día',
              }
            : undefined
        }
      />
    </div>
  );
};

export default BookingsCalendar;